function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BarbadosFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#2E42A5",
      d: "M16.5 3H24v18h-7.5V3Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FECA00",
      d: "M7.5 3h9v18h-9V3Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#2E42A5",
      d: "M0 3h7.5v18H0V3Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#212124",
      d: "M13.826 14.455c.474-.982 1.022-2.774 1.022-2.774l.415-1.233-1.646.596.39.226s-.68 1.358-1.021 2.02c-.343.664-.376.226-.376.226l.058-4.627.378-.102-.942-1.809-1.201 1.834.53.014s-.045 4.882-.118 4.69c-.041-.109-.15.228-.204.097-.334-.817-.79-2.402-.79-2.402l.267-.25-1.791-.369.535 1.102s.471 1.962.989 2.92c.117.303.68.433.68.433s.275-.28.343 0 0 1.406 0 1.406h1.266s-.09-1.063 0-1.406c.089-.343.365 0 .365 0s.734-.289.85-.592Z"
    })]
  })]
}));
//# sourceMappingURL=Barbados.js.map